export const ORIGIN = location.protocol + "//" + location.hostname + (location.port ? ':' + location.port : '');
export const BASE_URL = process.env.BASE_URL;
export const PDF_URL = ORIGIN + BASE_URL;// http://localhost:8100/open/
export const DEPLOY_PREFIX = process.env.VUE_APP_DEPLOY_PREFIX || '';
export const VUE_APP_BASE_URL = ORIGIN + DEPLOY_PREFIX + process.env.VUE_APP_BASE_URL; // http://localhost:8100/gbes-app-openbid
export const VUE_APP_SOCKET_URL =  ORIGIN + DEPLOY_PREFIX + process.env.VUE_APP_SOCKET_URL; // http://localhost:8100/gbes-common-service
export const LAYER_URL = PDF_URL + '/#/' // (location.href.indexOf('#') > -1 ? '/#/' : ''); // http://localhost:8100/open//#/ layer.open新页面

//文件服务
const fileServer = JSON.parse(sessionStorage.getItem('fileServer'));
let uploadUrl = DEPLOY_PREFIX + '/upload/fileSystem/uploadFile';
let downloadUrl='/nas';
if(fileServer!=null){
    uploadUrl = ORIGIN + DEPLOY_PREFIX +fileServer.uploadRoot + fileServer.uploadUrl;
    downloadUrl = ORIGIN + DEPLOY_PREFIX + fileServer.downloadRoot
}
export const UPLOAD_URL = uploadUrl;//上传
export const DOWNLOAD_URL = downloadUrl; //下载

export const GenerateQrCode = '/scanCode/v2/scan/generateQrCode'
export const GetSubjectInfo = '/scanCode/v2/scan/getSubjectInfo'
export const GetSealCertInfo = '/scanCode/v2/scan/getSealCertInfo' // 4.1.4	【签章端】获取印章集合及证书对象
export const GetDecryptInfo = '/scanCode/v2/scan/getDecryptInfo'
export const CloseChannel = '/scanCode/v2/scan/closeChannel' // 关闭通道

// 直播间 - 列表
export const queryStudioLocationList = '/xept/studioInfo/location/queryStudioLocationList.do' 
export const updateStudioLocationStage = '/xept/studioInfo/location/updateStudioLocationStage.do' 